import React from 'react';
import { Mail, MessageCircle, HelpCircle } from 'lucide-react';
import { ROUTES } from '../../lib/constants'; 

const AboutContent = ({ onNavigate, profile }) => {
  // Pre-configured dynamic strings for support paths
  const emailHref = "mailto:lukegreg36@gmail.com?subject=Support%20Request";
  const whatsappMessage = "Hello OmniClarix Support, I need some assistance with my account.";
  const whatsappHref = `https://api.whatsapp.com/send/?phone=2348079176939&text=${encodeURIComponent(whatsappMessage)}&type=phone_number&app_absent=0`;

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Header Title */}
      <div>
        <h3 className="hidden lg:block text-lg font-bold text-brown-900 mb-2">About OmniClarix</h3>
        <p className="text-xs text-brown-600">Core metrics, How It Works, and user support system</p>
      </div>

      {/* Setup Guide Banner */}
      <div className="border border-blue-200 rounded-xl p-4 bg-gradient-to-br from-blue-50/40 to-indigo-50/20">
        <h4 className="text-sm font-bold text-blue-900 mb-1">New to our Platform?</h4>
        <p className="text-xs text-blue-700 mb-3">Maximize textbook breakdown algorithms and quiz models with our setup guides.</p>
        <button 
          onClick={() => onNavigate(ROUTES.HOW_IT_WORKS)} 
          className="flex items-center justify-between w-full px-4 py-2.5 bg-white border border-blue-300 rounded-xl group text-xs sm:text-sm font-bold text-blue-900"
        >
          <div className="flex items-center space-x-2.5">
            <HelpCircle className="w-4 h-4 text-blue-600" />
            <span>Open the "How it Works" Guide</span>
          </div>
          <span className="text-blue-600 group-hover:translate-x-0.5 transition-transform">→</span>
        </button>
      </div>

      {/* Platform Operations Summary */}
      <div className="border border-cream-300 rounded-xl p-4 bg-white/50">
        <h4 className="text-sm font-semibold text-brown-900 mb-1.5">Clarix Operations</h4>
        <p className="text-xs sm:text-sm text-brown-700 leading-relaxed">
          Making textbook learning easier and more accessible for Nigerian students through the power of AI. 
          We simplify complex academic content, extract key concepts, and help students study smarter.
        </p>
      </div>

      {/* Complete Founder Biographical Card */}
      <div className="border border-cream-300/50 rounded-xl p-4 bg-gradient-to-br from-cream-100/50 to-brown-50/30 space-y-4">
        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
          <div className="flex-shrink-0 text-center">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-brown-300 to-brown-500 overflow-hidden border-2 border-white shadow-md mx-auto">
              <img src={profile?.avatar_url || "/founderpics.jpg"} alt="Peter Michael Oluwarotimi" className="w-full h-full object-cover" />
            </div>
            <p className="text-center text-xs sm:text-sm text-brown-500 mt-2 font-medium">
              Peter Michael Oluwarotimi
            </p>
          </div>

          <div className="flex-1 text-center sm:text-left">
            <h4 className="text-base sm:text-lg md:text-xl font-bold text-brown-900 mb-1">
              Built by a Student, For Students
            </h4>
            <p className="text-xs sm:text-sm text-brown-600 italic">
              Fellow Nigerian Student & Software Developer
            </p>
          </div>
        </div>

        <div className="space-y-3 sm:space-y-3.5 text-xs sm:text-sm md:text-base text-brown-700 leading-relaxed border-t border-cream-200/60 pt-3">
          <p>
             Hi, I'm a student just like you, and I know the struggle of dealing with thick and bulky textbooks, 
            limited time, and the pressure to understand everything before tests and exams.
          </p>
          <p>
            I created OmniClarix because I was tired of spending hours reading pages that could be simplified. 
            I wanted a tool that could help me and you grasp key concepts faster, prepare better for tests and exams, 
            and actually understand what we're studying—not just memorize it.
          </p>
          <p>
            This web app is my way of making student life easier. I'm passionate about solving problems and 
            helping fellow students succeed. Your feedback helps me make OmniClarix better every day.
          </p>
          <p className="font-semibold text-brown-900 text-sm sm:text-base">
            Let's succeed together.
          </p>
        </div>
      </div>

      {/* Helpdesk Channels - FIXED VERSION */}
      <div className="border border-cream-300 rounded-xl p-4 bg-white/50">
        <h4 className="text-sm font-semibold text-brown-900 mb-2">Helpdesk Channels</h4>
        <div className="grid grid-cols-2 gap-2">
          
          {/* Email Channel */}
          <a 
            href={emailHref}
            className="flex items-center justify-center space-x-1.5 py-2 bg-blue-600 hover:bg-blue-700 transition-colors text-white rounded-xl font-medium text-xs text-center"
          >
            <Mail className="w-3.5 h-3.5" />
            <span>Email</span>
          </a>

          {/* WhatsApp Channel - No more blank white pages */}
          <a 
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center space-x-1.5 py-2 bg-green-600 hover:bg-green-700 transition-colors text-white rounded-xl font-medium text-xs text-center"
          >
            <MessageCircle className="w-3.5 h-3.5" />
            <span>WhatsApp</span>
          </a>

        </div>
      </div>
    </div>
  );
};

export default AboutContent;